import axios from 'axios'
import { axiosClient, getCSRFToken } from 'www/utils'
import type { ApiConfirmSmsCodePostParams } from 'www/vue_components/common/UserAuthorization/api/apiConfirmSmsCode.types'

export default {
  cancelPostTokenSet: new Set<ReturnType<typeof axios.CancelToken.source>>(),
  cancelPost() {
    this.cancelPostTokenSet.forEach(cancelPostToken => {
      cancelPostToken.cancel()
    })
    this.cancelPostTokenSet.clear()
  },
  post(params: ApiConfirmSmsCodePostParams) {
    const formData = new FormData()

    formData.append('phone', params.phone)
    formData.append('code', params.code)
    formData.append('confirmation_request_id', params.confirmation_request_id)

    const cancelToken = axios.CancelToken.source()

    this.cancelPostTokenSet.add(cancelToken)

    return axiosClient.post(
      '/profile/ajax/confirm_sms_code/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-CSRFToken': getCSRFToken(),
        },
        cancelToken: cancelToken.token,
      },
    )
  },
}
